export const ClientRoute = {
  LOGIN: '/',
  LOGOUT: '/logged-out',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: (resetToken: string) => `/reset-password/${resetToken}`,
  ACTIVATE_MFA: '/activate-mfa',
  VALIDATE_MFA: '/validate-mfa',
  LOADING: '/loading',

  ADMIN_ADMINISTRATORS: 'admin/administrators',

  ADMIN_CHALLENGES: '/admin/challenges',
  ADMIN_CHALLENGES_PAST: '/admin/challenges/past',
  ADMIN_CHALLENGE_V1: (challengeId: string) => `/admin/challenges/v1/${challengeId}`,
  ADMIN_CHALLENGE: (challengeId: string) => `/admin/challenges/${challengeId}`,
  ADMIN_CHALLENGE_EDIT: (challengeId: string) => `/admin/challenges/${challengeId}/edit`,
  ADMIN_USER_CHALLENGE: (challengeId: string) => `/admin/user-challenges/${challengeId}`,
  ADMIN_CHALLENGE_NEW: '/admin/challenges/new',
  ADMIN_CHALLENGE_VIEW_SETTINGS: (challengeId: string) => `/admin/challenges/${challengeId}/view-settings`,

  ADMIN_GAME_SETTINGS: (gameId: number) => `/admin/games/${gameId}/settings`,
  ADMIN_GAME_LEADERBOARD: (gameId: number) => `/admin/games/${gameId}/leaderboard`,

  ADMIN_USERS: '/admin/users',
  ADMIN_USER: (userId: number, page?: string) => `/admin/users/${userId}/${page || ''}`,

  ADMIN_CLUB_SEARCH: '/admin/clubs',
  ADMIN_COURSE_SEARCH: '/admin/clubs/courses',
  ADMIN_CLUB_COURSE: (clubId: number, courseId: number) => `/admin/clubs/${clubId}/courses/${courseId}`,
  ADMIN_CLUB_COURSES: (clubId: number) => `/admin/clubs/${clubId}/courses`,
  ADMIN_ADD_NEW_CLUB_COURSE: (clubId: number) => `/admin/clubs/${clubId}/courses/new`,
  ADMIN_COURSE_GPS_EDITOR: (params: string) => `/admin/courses/gps-editor?${params}`,

  COURSE_EDITOR_FRONT_PAGE: '/course-editor',
  COURSE_EDITOR_COURSE_SEARCH: '/course-editor/search',
  COURSE_EDITOR_COURSE: (courseId: number) => `/course-editor/courses/${courseId}`,
  COURSE_EDITOR_GPS: (courseId: number) => `/course-editor/gps?courseId=${courseId}`,
}
